/* eslint-disable @typescript-eslint/no-explicit-any */
export const widgetWithDatasourceDefaultConfig = {
    datasourceId: null,
    subTableDatasourceChannelId: null,
};
